import React, {useContext, useEffect, useState} from 'react';
import i18n from 'i18next';
import {Box, MenuItem, TextField, Typography} from '@mui/material';
import {SidebarContext} from "../../contexts/SidebarContext";
import {useTranslation} from "react-i18next";


interface LanguageSelectorProps {
    isSidebarSelector?: boolean,
}
function LanguageSelector({isSidebarSelector}: LanguageSelectorProps) {
    const { sidebarToggle } = useContext(SidebarContext);
    const { t } = useTranslation();

    const languages = ['et', 'en', 'ru', 'no'];
    const [languageId, setLanguageId] = useState(languages.find((value => i18n.language.includes(value))) ?? languages[1]);

    useEffect(() => {
        if (i18n.language !== languageId) {
            i18n.changeLanguage(languageId).then();
        }
    }, [languageId]);

    const languageClicked = (id: string) => {
        if (i18n.language !== id) {
            setLanguageId(id);
        }
    };

    return (
        <Box sx={{display: 'flex', justifyContent: 'center', width: '100%', margin: '0 auto', pb: isSidebarSelector ? 1 : 0}}>
            <TextField
                label={t('language')}
                value={languageId}
                variant="outlined"
                select
                size="small"
                SelectProps={sidebarToggle || !isSidebarSelector ? {} : { IconComponent: () => null }}
                sx={{
                    width: sidebarToggle || !isSidebarSelector ? '70px' : '50px',
                    '& fieldset': {borderColor: 'rgba(0, 0, 0, 0.7)', p: 0.5},
                    '& label': {marginLeft: '-5px'}
                }}
            >
                {languages.map(language =>
                    <MenuItem key={language} value={language} onClick={() => languageClicked(language)} sx={{
                        display: 'flex', justifyContent: 'center', margin: 0
                    }}>
                        <Typography align="center" sx={{
                            fontWeight: '500',
                            fontSize: sidebarToggle || !isSidebarSelector ? {xs: '14px', sm: '16px'} : '14px',
                            lineHeight: 1.5,
                            padding: sidebarToggle || !isSidebarSelector ? '0 2px' : 0,
                            margin: 0,
                        }}>
                            {language.toUpperCase()}
                        </Typography>
                    </MenuItem>
                )}
            </TextField>
        </Box>
    );
}

export default LanguageSelector;